import { render } from "./RegisterOfficial.vue?vue&type=template&id=612dacfa&scoped=true"
import script from "./RegisterOfficial.vue?vue&type=script&lang=js"
export * from "./RegisterOfficial.vue?vue&type=script&lang=js"

import "./registerOfficial.css?vue&type=style&index=0&id=612dacfa&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612dacfa"]])

export default __exports__